export default __webpack_public_path__ + "static/media/ataLogo.dc09a270.png";